import React, { useState, useRef, useEffect } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import './ImageCarousel.css'

const ImageCarousel = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)
  const trackRef = useRef(null)
  const intervalRef = useRef(null)

  const minSwipeDistance = 50

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1))
  }

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1))
  }

  useEffect(() => {
    if (images.length > 1) {
      intervalRef.current = setInterval(() => {
        goToNext()
      }, 3000)

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images.length, currentIndex])

  const pauseAutoPlay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
    }
  }

  const resumeAutoPlay = () => {
    if (images.length > 1) {
      intervalRef.current = setInterval(() => {
        goToNext()
      }, 3000)
    }
  }

  const onTouchStart = (e) => {
    pauseAutoPlay()
    setTouchEnd(null)
    setTouchStart(e.targetTouches[0].clientX)
  }

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX)
  }

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) {
      resumeAutoPlay()
      return
    }

    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > minSwipeDistance
    const isRightSwipe = distance < -minSwipeDistance

    if (isLeftSwipe) {
      goToNext()
    }
    if (isRightSwipe) {
      goToPrevious()
    }

    resumeAutoPlay()
  }

  const handleButtonClick = (action) => {
    pauseAutoPlay()
    action()
    resumeAutoPlay()
  }

  if (!images || images.length === 0) {
    return (
      <div></div>
      // <div className='carousel-container'>
      //   <div className='empty-state'>
      //     <p className='empty-text'>Görüntülenecek resim bulunamadı</p>
      //   </div>
      // </div>
    )
  }

  if (images.length === 1) {
    return (
      <div className='carousel-container'>
        <div className='single-image-container'>
          <img src={'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' + images[0]} alt='Tek resim' className='single-image' />
        </div>
      </div>
    )
  }

  return (
    <div className='carousel-container'>
      <div className='carousel-wrapper' onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} onMouseEnter={pauseAutoPlay} onMouseLeave={resumeAutoPlay}>
        <div ref={trackRef} className='carousel-track' style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
          {images.map((image, index) => (
            <div key={index} className='carousel-slide'>
              <img src={'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' + image} alt={`Slide ${index + 1}`} className='carousel-image' />
            </div>
          ))}
        </div>

        <button onClick={() => handleButtonClick(goToPrevious)} className='nav-button prev'>
          <ChevronLeft size={24} />
        </button>

        <button onClick={() => handleButtonClick(goToNext)} className='nav-button next'>
          <ChevronRight size={24} />
        </button>
      </div>
    </div>
  )
}

export default ImageCarousel
